import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import {
  i18n,
  vuetify,
  nextFocus,
  nextFocusTab,
  numericInput,
  api,
  loading,
  confirm,
  dialogEscKey
} from './plugins'
import Toast from 'vue-toastification' // Import Toast types
import PortalVue from 'portal-vue'
import 'vue-toastification/dist/index.css'
import {
  ToastComponent,
  ToastID,
  ToastOptions
} from 'vue-toastification/dist/types/src/types'
import { auth } from '@/services/auth'
// import { Amplify } from 'aws-amplify'

// Amplify.configure({
//   Auth: {
//     region: process.env.VUE_APP_COGNITO_REGION,
//     userPoolId: process.env.VUE_APP_COGNITO_USERPOOL_ID,
//     userPoolWebClientId: process.env.VUE_APP_COGNITO_USERPOOL_APP_CLIENT_ID,
//     oauth: {
//       domain: process.env.VUE_APP_COGNITO_DOMAIN_NAME,
//       scope: ['email','openid','profile','aws.cognito.signin.user.admin',`${process.env.VUE_APP_COGNITO_CATALOG_MS_RESOURCES_SERVER}/all:all`],
//       redirectSignIn: process.env.VUE_APP_COGNITO_REDIRECT_SIGN_IN,
//       redirectSignOut: process.env.VUE_APP_COGNITO_REDIRECT_SIGN_OUT,
//       responseType: 'code'
//     }
//   }
// })

Vue.config.productionTip = false
Vue.use(PortalVue)
Vue.use(confirm)
Vue.use(loading)
Vue.use(dialogEscKey)

// Install vue-toastification with default options (hideProgressBar: true)
Vue.use(Toast, { hideProgressBar: true }) // Cast options to PluginOptions

// IMPORTANT: Ensure Vue.prototype.$toast exists before attempting to wrap its methods.
// This check prevents errors if the Toast plugin fails to install for some reason.
if ((Vue.prototype as any).$toast) {
  // Cast to 'any' to bypass initial type check if $toast is not yet declared
  // Store original toast methods to call them from our wrapper
  const originalToastMethods: Record<string, any> = {} // Use Record for string-keyed object
  const toastMethodNames = ['success', 'error', 'info', 'warning'] // Common toast methods
  // other unecessary methods: default, clear, update, dismiss

  // Wrap each relevant toast method
  toastMethodNames.forEach((methodName) => {
    // Access $toast via 'any' cast initially to ensure it's treated as a potential function
    const toastInstance = (Vue.prototype as any).$toast
    if (typeof toastInstance[methodName] === 'function') {
      originalToastMethods[methodName] = toastInstance[methodName]

      // Override the method. Use 'this: Vue' to correctly type the Vue instance within the method.
      ;(Vue.prototype.$toast as any)[methodName] = function (
        this: Vue,
        message: string | ToastComponent,
        options?: ToastOptions
      ): ToastID {
        // Call the original toast method first to display the toast
        const toastId: ToastID = originalToastMethods[methodName].call(
          this,
          message,
          options
        )

        // Determine the toast type for logging
        let typeToLog: string = methodName
        // For the generic $toast() call (which maps to 'default' or 'show'),
        // we might infer type from options if explicitly provided.
        if (methodName === 'default' && options && options.type) {
          typeToLog = options.type
        }

        // Return the toast ID received from the original method
        return toastId
      }
    }
  })
} else {
  console.warn(
    '⚠️ Vue-toastification plugin not found on Vue.prototype.$toast. Toast logging will not be enabled.'
  )
}

Vue.directive('next-focus', { inserted: nextFocus })
Vue.directive('next-focus-tab', { inserted: nextFocusTab })
Vue.directive('numeric-input', { inserted: numericInput })

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App)
}).$mount('#app')
